import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { canViewGuard } from './core/guards/can-view.guard';
import { CCAPermissions } from './core/permissions/permissions.facade';

export const routes: Routes = [
  {
    path: '',
    canMatch: [authGuard],
    children: [
      { path: '', redirectTo: '/home', pathMatch: 'full' },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'living',
        canMatch: [canViewGuard(CCAPermissions.COL_READ)],
        title: 'College Cost Admin - Living',
        loadChildren: () => import('./features/living/living.routes'),
      },
      {
        path: 'fees',
        canMatch: [canViewGuard(CCAPermissions.FEE_READ)],
        title: 'College Cost Admin - Fees',
        loadChildren: () => import('./features/fees/fees.routes'),
      },
      {
        path: 'tuition',
        canMatch: [canViewGuard(CCAPermissions.TUITION_RATE_READ)],
        title: 'College Cost Admin - Tuition',
        loadChildren: () => import('./features/tuition/tuition.routes'),
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./features/access-denied/access-denied.component'),
      },
      {
        path: '**',
        loadComponent: () => import('./features/not-found/not-found.component'),
      },
    ],
  },
];
